<template>
  <modal :show-close="modalConfig.showClose"
         :wrapper-classes="modalConfig.wrapperClasses"
         @close="$emit('reject')">
    <h2 slot="header" class="modal-title text-3xl text-center sm:text-4xl mt-5 sm:mt-10">
      digital voucher
    </h2>
    <h4 slot="subHeader" class="text-xs text-gray-700 text-center font-light px-0 sm:px-10 sm:text-xl">
      configure a digital voucher that will send out to your recipients and display in their loyalty rewards wallet
    </h4>
    <div slot="body">
      <div v-if="error" class="error-message text-center callout alert">{{error}}</div>
      <digital-voucher-form
        :digitalVoucherDraftState.sync="digitalVoucherDraftState"
        :campaign="campaign"
      />
    </div>
    <div slot="action" class="modal-action-click">
      <button class="button done-button" :disabled="isDoneButtonDisabled" @click="clickedDone()" data-cy="digital-voucher-done-button">done</button>
    </div>
  </modal>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import DigitalVoucherForm from "../forms/digital-voucher-form.vue";
import Modal from "../../../shared/Modal.vue";

export default {
  props: {
    campaign: Object,
    extension: Object,
    error: null,
  },


  name: "digital-voucher-modal",

  components: {Modal, DigitalVoucherForm},

  data() {
    return {
      alert: null,
      digitalVoucherDraftState: null,
      modalConfig: {
        showClose: true,
        wrapperClasses: ["extensions-modal","digital-voucher-modal"]
      },
    }
  },

  async created() {
    this.digitalVoucherDraftState = _.cloneDeep(this.extension.payload);
  },

  methods: {
    clickedDone() {
      this.extension.payload = this.digitalVoucherDraftState;
      this.$emit("resolve", this.extension);
    }
  },

  computed: {
    flatPickrConfig() {
      return {
        minDate: new Date()
      }
    },
    isDoneButtonDisabled() {
      return !this.digitalVoucherDraftState.item_name || !this.digitalVoucherDraftState.expiration_date
    },
    ...mapGetters(["currentMerchant"])
  }
}
</script>

<style scoped>
.digital-voucher,
.digital-voucher-modal >>> .attachment-container,
.digital-voucher-modal >>> .column {
  align-items: start;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.digital-voucher-modal >>> .column {
  margin-bottom: 15px;
}

.digital-voucher-modal >>> select,
.digital-voucher-modal >>> input {
  font-size: 18px;
}

.digital-voucher-modal >>> a {
  font-family: "AileronLight",sans-serif;
  margin-bottom: 5px;
}

.digital-voucher-modal >>> svg {
  height: 4rem;
  width: 4rem;
}

.digital-voucher-modal >>> img {
  border: 1px solid #128ff9;
  height: 75px;
  margin-top: 8px;
}

.digital-voucher-modal >>> span.remove-btn {
  color: #a4a4a4;
  cursor: pointer;
  font-size: .9em;
  margin-left: 15px;
}

.digital-voucher-modal >>> .remove-btn:hover{
  color: #f91253;
}

.digital-voucher-modal >>> input,
.digital-voucher-modal >>> select,
.digital-voucher-modal >>> .expiration-date {
  margin-bottom: 0;
  width: 100%;
}

.digital-voucher-modal >>> .expiration-date {
  border: 1px solid #128ff9;
  border-radius: 8px;
}

.digital-voucher-modal >>> .expiration-date > .label-container {
  color: #000;
}

.digital-voucher-modal >>> .error {
  border-color: #f91253;
}

.digital-voucher-modal >>> .sb-loading-icon {
  margin-top: 8px;
}

.sb-loading-icon >>> svg {
  fill: #128ff9;
}

.done-button {
  min-width: 10rem;
  top: 1rem !important;
}
</style>
